import { createReducer, on } from '@ngrx/store'
import { IEmailProposalState, IContact } from '../../models/email-proposal.models'
import { EmailProposalActions } from '../actions/email-proposal.actions'
import { CHARACTER_SETS } from '../../../../core/constants/regex.constants'

const initialState: IEmailProposalState = {
    proposalData: null,
    documents: [],
    contacts: [],
    emailTemplates: [],
    emailData: {
        to: [],
        cc: [],
        subject: '',
        message: '',
        username: '',
        password: '',
        attachments: [],
    },
    isLoading: false,
    error: null,
    showPreview: false,
    showAddContact: false,
    confirmationChecked: false,
}

export const emailProposalReducer = createReducer(
    initialState,
    on(EmailProposalActions.loadProposalData, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
    on(EmailProposalActions.loadProposalDataSuccess, (state, { proposalData }) => ({
        ...state,
        proposalData,
        isLoading: false,
        emailData: {
            ...state.emailData,
            subject: `${proposalData.offering} Proposal for ${proposalData.schoolName}`,
            username: Math.floor(Math.random() * 10000000).toString(),
        },
    })),
    on(EmailProposalActions.loadDocumentsSuccess, (state, { documents }) => ({
        ...state,
        documents,
        emailData: {
            ...state.emailData,
            attachments: documents,
        },
    })),
    on(EmailProposalActions.loadEmailTemplatesSuccess, (state, { templates }) => ({
        ...state,
        emailTemplates: templates,
    })),
    on(EmailProposalActions.updateEmailField, (state, { field, value }) => ({
        ...state,
        emailData: {
            ...state.emailData,
            [field]: value,
        },
    })),
    on(EmailProposalActions.addContact, (state, { contact }) => {
        const contactWithId = { ...contact, id: Date.now().toString() }
        return {
            ...state,
            contacts: [...state.contacts, contactWithId],
            emailData: {
                ...state.emailData,
                cc: [...state.emailData.cc, contactWithId],
            },
        }
    }),
    on(EmailProposalActions.generatePassword, (state) => ({
        ...state,
        emailData: {
            ...state.emailData,
            password: generateSecurePassword(),
        },
    })),
    on(EmailProposalActions.showPreview, (state) => ({
        ...state,
        showPreview: true,
    })),
    on(EmailProposalActions.hidePreview, (state) => ({
        ...state,
        showPreview: false,
    })),
    on(EmailProposalActions.showAddContactDialog, (state) => ({
        ...state,
        showAddContact: true,
    })),
    on(EmailProposalActions.hideAddContactDialog, (state) => ({
        ...state,
        showAddContact: false,
    })),
    on(EmailProposalActions.removeContact, (state, { contactId }) => ({
        ...state,
        contacts: state.contacts.filter((contact: IContact) => contact.id !== contactId),
        emailData: {
            ...state.emailData,
            cc: state.emailData.cc.filter((contact: IContact) => contact.id !== contactId),
        },
    })),
    on(EmailProposalActions.updateDocuments, (state, { documents }) => ({
        ...state,
        documents,
        emailData: {
            ...state.emailData,
            attachments: documents,
        },
    })),
    on(EmailProposalActions.removeAttachment, (state, { fileId }) => ({
        ...state,
        emailData: {
            ...state.emailData,
            attachments: state.emailData.attachments.filter(
                (attachment) => attachment.id !== fileId,
            ),
        },
    })),
    on(EmailProposalActions.updateConfirmationStatus, (state, { checked }) => ({
        ...state,
        confirmationChecked: checked,
    })),
)

function generateSecurePassword(): string {
    const chars = CHARACTER_SETS.PASSWORD_CHARS
    let result = ''
    for (let i = 0; i < 12; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return result
}
